import React from 'react';
import MetaElement from '../components/elements/MetaElement';
import AuctionList from '../components-v2/auctions/AuctionList';
import { normalizeAuction } from '../components-v2/auctions/auctionUtils';
import Api from '../utils/api';

const AuctionsPage = props => <><MetaElement pageId="licitatii" /><AuctionList {...props} /></>;

AuctionsPage.getInitialProps = async ctx => {
  const breadcrumbs = [{ label: ctx.locale === 'en' ? 'Auctions' : 'Licitații', href: '/licitatii' }];
  try {
    const response = await Api.get('/v2/public/auctions', null, null, ctx);
    if (!response.success || !Array.isArray(response.data?.auctions)) throw new Error('Auctions unavailable');
    return { auctions: response.data.auctions.map(normalizeAuction), breadcrumbs };
  } catch {
    return { auctions: [], loadError: true, breadcrumbs };
  }
};

export default AuctionsPage;
